import type { UserPermissions } from "@appType/types";
import { create } from "zustand";

interface PermissionStore {
	permissions: UserPermissions;
	initialized: boolean;
	setPermissions: (permissions: UserPermissions) => void;
	resetPermissions: () => void;
}

const createDefaultPermissions = (): UserPermissions => ({
	see_all_logs: false,
	create_and_score_application: false,
	get_report: false,
	manage_users: false,
	scoring_settings: false,
	model_settings: false,
	ocr_settings: false,
	archive_and_restore_applications: false,
	delete_applications: false,
	see_shap: false,
	audit: false,
	perform_group_scoring: false,
	score_bulk: false,
	root: false,
	read_results: false,
	read_dashboard: false,
	ifrs_config: false,
	perform_ifrs: false,
	edit_and_rescore_application: false,
	assign_edit_rights: false,
	edit_assigned_application: false,
	edit_and_rescore_own_application: false,
	notion_ticketing: false,
	approval_override_history: false,
	see_threshold: false,
	approve_model_changes: false,
});

export const usePermissionStore = create<PermissionStore>((set) => ({
	permissions: createDefaultPermissions(),
	initialized: false,
	setPermissions: (permissions) =>
		set({
			permissions,
			initialized: true,
		}),
	resetPermissions: () =>
		set({
			permissions: createDefaultPermissions(),
			initialized: false,
		}),
}));
